import { render } from "./SubmitTransaction.vue?vue&type=template&id=7380c01b"
import script from "./SubmitTransaction.vue?vue&type=script&lang=js"
export * from "./SubmitTransaction.vue?vue&type=script&lang=js"

import "./SubmitTransaction.vue?vue&type=style&index=0&id=7380c01b&lang=css"
script.render = render

export default script